package hk.com.vr360_demo2.webapp.component.viewer.component

import emotion.react.css
import hk.com.vr360_demo2.webapp.Colors
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.span
import web.cssom.AlignItems
import web.cssom.Background
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.JustifyContent
import web.cssom.px
import web.cssom.pct
import hk.com.vr360_demo2.webapp.component.common.toggleFullscreen
import kotlin.js.unsafeCast

external interface HeaderBarProps : Props {
    var logoUrl: String?
    var title: String
}

val HeaderBar = FC<HeaderBarProps> { props ->
    div {
        css {
            display = Display.flex
            flexDirection = FlexDirection.row
            alignItems = AlignItems.center
            justifyContent = JustifyContent.spaceBetween
            width = 100.pct
            paddingTop = 10.px
        }
        // 左側 logo — 固定寬度，不壓縮
        div {
            css {
                display = Display.flex
                alignItems = AlignItems.center
                width = 150.px
                paddingLeft = 10.px
                asDynamic().flexShrink = 0
                asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                    width = 80.px
                }
            }

            if(!props.logoUrl.isNullOrEmpty()){
                img {
                    src = props.logoUrl
                    alt = "logo"
                    css {
                        width = 150.px
                        height = web.cssom.Auto.auto
                        asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                            width = 80.px
//                        marginTop = 80.px
                        }
                    }
                }
            }
        }
        // 中間 title — 佔據剩餘空間，文字溢出省略
        div {
            css {
                asDynamic().flex = 1
                asDynamic().minWidth = 0
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center

//                marginTop = 10.px
            }
            span {
                css {
                    fontSize = 16.px
                    fontWeight = web.cssom.FontWeight.normal
                    color = Colors.Text.White
                    overflow = web.cssom.Overflow.hidden
                    whiteSpace = web.cssom.WhiteSpace.nowrap
                    background = Colors.Background.Semitransparent
                    paddingBottom = 8.px
                    paddingTop = 8.px
                    paddingLeft = 12.px
                    paddingRight = 12.px
                    borderRadius = 8.px
                    textOverflow = web.cssom.TextOverflow.ellipsis
                    asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                        fontSize = 14.px
                    }
                }
                +props.title
            }
        }
        // 右側按鈕組 — 固定寬度，不壓縮
        div {
            css {
                display = Display.flex
                flexDirection = FlexDirection.column
                alignItems = AlignItems.center
                gap = 8.px
                width = 150.px

                asDynamic().flexShrink = 0
                asDynamic().pointerEvents = "auto"
                asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                    width = 80.px
                }
            }
            button {
                title = "全屏"
                css {
                    background = "none".unsafeCast<Background>()
                    border = 0.px
                    cursor = web.cssom.Cursor.pointer
                    padding = 8.px
                }
                onClick = { toggleFullscreen() }
                img {
                    src = "/assets/images/full.svg"
                    alt = "全屏"
                    css {
                        width = 36.px
                        height = 36.px
//                        asDynamic().filter = "invert(1) brightness(2)"
                        cursor = web.cssom.Cursor.pointer
                        asDynamic().transition = "transform 0.2s ease"
                        hover {
                            asDynamic().transform = "scale(1.2)"
                        }
                        asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                            width = 24.px
                            height = 24.px
                        }

                    }
                }
            }
        }
    }
}
